<!--
 * @Author: 范向玲
 * @Date: 2023-02-10 14:41:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-04 15:50:27
 * @Description: 新增机构
 * @FilePath: \web\src\components\DataManagement\institutionManagement\addOrg.vue
-->
<template>
  <section id="add-org">
    <a-form ref="orgForm" :model="formData" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-form-item label="单位类型" name="parentId" :rules="[{ trigger: 'change', required: true, message: '请选择!' }]">
        <a-tree-select v-model:value="formData.parentId" show-search style="width: 100%" placeholder="请选择"
          :treeData="[...[{ title: '无上级机构', id: '0', key: 'null' }], ...orgTree]"
          :replaceFields="{ label: 'name', key: 'id', value: 'id' }" allow-clear>
        </a-tree-select>
      </a-form-item>
      <a-form-item label="单位名称" name="name" :rules="[{ trigger: 'blur', required: true, message: '请输入!' }]">
        <a-input v-model:value="formData.name" />
      </a-form-item>
      <a-form-item label="矿种权限" name="mineralIds">
        <div class="mineralIds-item">
          <section class="mineral-type-cascader" @click="openMineral">
            {{ getPrimary }}
            <!-- <CaretDownOutlined /> -->
          </section>

          <MineralTypeVue ref="mineralTypeVue" allInType="true" :visible="mineralVisible" :selectList="mineralIds"
            :list="minerals" @close="openMineral" @submit="mineralSubmit" style="top: 0.48rem" />
        </div>
      </a-form-item>
      <a-form-item label="研报权限" name="reportTypes"
        :rules="[{ trigger: 'change', required: true, message: '请选择!', whitespace: false, transform: (value) => (value || []).toString() }]">
        <a-select class="report-type-cascader" option-label-prop="label" mode="multiple"
          v-model:value="formData.reportTypes" :options="reportTypeList" @change="blur" />
      </a-form-item>
      <a-form-item label="区域权限" name="areaIds"
        :rules="[{ trigger: 'change', required: true, message: '请选择!', whitespace: false, transform: (value) => (value || []).toString() }]">
        <a-select class="report-type-cascader" option-label-prop="label" mode="multiple"
          v-model:value="formData.areaIds" :options="areaIdsList" @change="blur" />
      </a-form-item>
      <a-form-item label="序号" name="sortNum">
        <a-input v-model:value="formData.sortNum" />
      </a-form-item>
    </a-form>
  </section>
</template>

<script setup>
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import { useStore, } from 'vuex';
import { ref, computed, toRefs, watch, onMounted, onBeforeMount, defineProps, defineEmits, defineExpose, } from 'vue';
import MineralTypeVue from '@/components/ProjectLibrary/main/orenodeSearch/keySearch/mineralTypeId.vue';
import { getDicInfoApi } from '@/api/drillLibrary/utilsApi';
import { getRegionApi } from '@/api/utils/utilsApi';
import { message } from 'ant-design-vue';
const props = defineProps({
  formState: {
    required: true,
  },
  orgTree: {
    require: true,
  },
  modalType: {
    require: true,
  },
  mineralIdList: {
    require: true,
  },
});


const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
const generalState = computed(() => state.general);
const { minerals, } = toRefs(generalState.value);

let formData = JSON.parse(JSON.stringify(props.formState));


const orgForm = ref();
const emit = defineEmits(['confirmAdd', '',]);

const mineralIds = ref([]);
const mineralNames = ref(props.mineralIdList);
const reportTypeList = ref([]);
const areaIdsList = ref([]);

defineExpose({ orgForm, mineralIds, });

// const confirmAdd = () => {
//   emit('addmoooo', )
// };

const mineralVisible = ref(false);
const mineralTypeVue = ref(null);
/**
 * @description 打开矿种选择
 */
const openMineral = () => {
  mineralVisible.value = !mineralVisible.value;
};

// computed
const getPrimary = computed(() => {
  mineralNames.value = [];

  mineralIds.value && mineralIds.value.forEach(item => {
    const arr = minerals.value.filter(ele => {
      return item == ele.id;
    });

    arr.length > 0 && mineralNames.value.push(arr[0].name);
  });
  return mineralNames.value.join(',');
});
const blur = (v) => {
  console.log('blur', v, formData);
};
/**
 * @description 确认矿种选择
 */
const mineralSubmit = (value) => {
  mineralIds.value = value;
  openMineral();
};
/**
* 获取报告种类
*/
const getReportTypeList = () => {
  getDicInfoApi('dicType=report').then((res) => {
    let list = [];

    res.data.forEach((ele, i) => {
      list.push({ id: i, name: ele, label: ele, value: ele, });
    });
    reportTypeList.value = list;
  });
}
/**
* 获取区域
*/
const getaAreaIdsList = () => {
  getRegionApi().then((res) => {
    const list = [{ value: '1', label: '中国' }]
    if (res.code === 200) {
      res.data.map((item) => {
        list.push({ ...item, value: item.id, label: item.countryName, })
      });
      areaIdsList.value = list
    } else {
      message.error(res.msg || '网络故障请联系管理员')
    }
  });
}
onMounted(() => {
  getReportTypeList();
  getaAreaIdsList();

});
watch(props.formState, (val, old) => {
  if (val) {
    formData = val;
    mineralIds.value = val.mineralIds || [];
  }
}, {
  deep: true,
  immediate: true,
});

</script>

<style lang="scss">
#add-org {
  span {
    color: #fff;
  }

  .ant-form-item-label>label {
    color: #fff;
  }

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;
    // height: 0.34rem;
    // padding: 0.1rem;

    .ant-select-selector {
      height: 100%;
      // height: 0.34rem;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
      // height: 0.34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      // background-color: rgba(91, 76, 39, 0.4);
      background-color: transparent;
      border: 1px solid #695933;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      // height: 0.34rem;
      color: #fff;
    }
  }

  .ant-select-multiple .ant-select-selection-item {
    background-color: rgba(91, 76, 39, 0.4);
  }

  .ant-select-multiple .ant-select-selection-item-content {
    margin-top: -0.1rem;
    padding-top: 0.05rem;
  }

  .ant-select-multiple .ant-select-selection-item-remove {
    color: #fff;
    margin-top: -0.05rem;
  }

  span .ant-input-password .ant-input-affix-wrapper {
    background-color: transparent;
  }

  .ant-input-password-icon {
    color: #fff;
  }

  .mineralIds-item {
    position: relative;
    line-height: 0.34rem;
    background-color: transparent;
    color: #fff;
    padding: .05rem .1rem;
    border: 0.01rem solid #695933;
    cursor: pointer;

    .mineral-type-cascader {
      min-height: .34rem;
    }
  }

  .report-type-cascader {
    .ant-select-selector {
      padding: 0.08rem;
    }
  }
}
</style>